import * as angular from 'angular';
import * as moment from 'moment';
import {Strings} from "../shared/config/constant.module";

interface DateTimePickerScope extends angular.IScope {
  singleHour: any;
  showCurrentTimeLink: any;
  showFoundTimeLink: any;
  isSecondHour: boolean;
  showSecondHour: boolean;
  timeModel: Date;
  ngModel: Date;
  foundTime: Date;
  setCurrentTime: () => void;
  setFoundTime: () => void;
  timeZone: string;
  timeChanged: () => any;
}

export default angular.module('aps.directives.dateTimePicker', [])
  .directive('dateTimePicker', ($compile: angular.ICompileService,
                                $timeout: angular.ITimeoutService): angular.IDirective => {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        ngModel: '=',
        timeModel: '=',
        timeZone: '=',
        foundTime: '=',
        singleHour: '@',
        showCurrentTimeLink: '@',
        showFoundTimeLink: '@',
        timeChanged: '&'
      },
      link: (scope: DateTimePickerScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: angular.INgModelController) => {
        scope.singleHour = (scope.singleHour === 'true');
        scope.showCurrentTimeLink = (scope.showCurrentTimeLink === 'true');
        scope.showFoundTimeLink = (scope.showFoundTimeLink === 'true');
        scope.isSecondHour = false;
        scope.showSecondHour = false;

        var enableDisableSecondHour = () => {
          var timeZoneMoment = moment.tz(scope.timeModel, scope.timeZone);
          var secondHour = moment.tz(scope.timeModel, scope.timeZone).subtract(1, 'hours').hour() === timeZoneMoment.hour();
          if (scope.isSecondHour !== secondHour) {
            scope.isSecondHour = secondHour;
          }
          scope.showSecondHour = secondHour ||
            (moment.tz(scope.timeModel, scope.timeZone).add(1, 'hours').hour() === timeZoneMoment.hour());
        };

        var setTimeZoneTime = (value) => {
          if (!scope.timeModel || !value || scope.timeModel.getTime() !== value.getTime()) {
            scope.timeModel = value;
            enableDisableSecondHour();
            if (scope.timeChanged) {
              $timeout(() => scope.timeChanged());
            }
          }
        };

        var getTimeZoneTime = (value) => {
          if (!value) {
            return value;
          }
          var newDate = moment.tz(moment(value).format(Strings.TIME_FORMAT), Strings.TIME_FORMAT, scope.timeZone).toDate();
          if (scope.showSecondHour && scope.isSecondHour) {
            newDate = moment.tz(newDate, scope.timeZone).add(1, 'hours').toDate();
          }
          return newDate;
        };

        var getLocalTime = (value: Date) => {
          if (!value) {
            scope.showSecondHour = false;
            scope.isSecondHour = false;
            return value;
          }
          var timeZoneMoment = moment.tz(value, scope.timeZone);
          return moment(timeZoneMoment.format(Strings.TIME_FORMAT), Strings.TIME_FORMAT).toDate();
        };

        let setLocalTime = (value) => {
          if (!value) {
            if (!scope.ngModel) {
              return;
            }
          } else if (scope.ngModel && scope.ngModel.getTime() === value.getTime()) {
            return;
          }

          scope.ngModel = value;
          enableDisableSecondHour();
          if (scope.timeChanged) {
            $timeout(() => scope.timeChanged());
          }
        };

        if (scope.timeModel) {
          scope.ngModel = getLocalTime(scope.timeModel);
          enableDisableSecondHour();
        }

        ngModel.$parsers.push(function(val) {
          setTimeZoneTime(getTimeZoneTime(val));
          return val;
        });

        scope.setCurrentTime = () => {
          scope.timeModel = moment().startOf('minute').toDate();
          scope.ngModel = getLocalTime(scope.timeModel);
          enableDisableSecondHour();
        };

        scope.setFoundTime = () => {
          scope.timeModel = moment(scope.foundTime).startOf('minute').toDate();
          scope.ngModel = getLocalTime(scope.timeModel);
          enableDisableSecondHour();
        };

        var templateElement = angular.element('<label ng-show="showSecondHour" class="ng-hide" />');
        templateElement.append('Is Second Hour ');
        templateElement.append('<input type="checkbox" ng-model="isSecondHour" ng-disabled="singleHour" />');

        var compiledElement = $compile(templateElement)(scope);
        element.after(compiledElement);

        if (scope.showCurrentTimeLink || scope.showFoundTimeLink) {
          var linkTemplate = angular.element('<div style="position: relative; top: 7px; right: 0;" />');
          if (scope.showCurrentTimeLink) {
            linkTemplate.append('<a ng-click="setCurrentTime()">current time</a>');
          }
          if (scope.showFoundTimeLink) {
            if (scope.showCurrentTimeLink) {
              linkTemplate.append(' | ');
            }
            linkTemplate.append('<a ng-click="setFoundTime()">found time</a>');
          }
          compiledElement = $compile(linkTemplate)(scope);
          element.after(compiledElement);
        }

        scope.$watch('isSecondHour', function() {
          setTimeZoneTime(getTimeZoneTime(ngModel.$modelValue));
        });

        scope.$watch('timeZone', function() {
          setTimeZoneTime(getTimeZoneTime(ngModel.$modelValue));
        });

        scope.$watch('timeModel', function(value: Date) {
          setLocalTime(getLocalTime(value));
        });
      }
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/directives/date-time-picker.ts